import React, { ReactNode } from 'react';
import { useFormik } from 'formik';
// import _ from 'lodash';

import {
  Row,
  Col,
  Form,
  Button,
  Offcanvas,
  Modal,
  Tabs,
  Tab,
  // DropdownButton,
  // Dropdown,
} from 'react-bootstrap';
// import styled from 'styled-components';
// import { up, down } from 'styled-breakpoints';

import { Spin, Switch, Divider } from 'antd';
import CurrencyInput from 'react-currency-input-field';

// Auth
// import { useAuthContext } from '../../../auth/use-auth-context.js';
import { useRouter } from '../../../../auth/auth-guard';

import SmartSelect from '../../../../components/select/SmartSelect.tsx';
import Select from '../../../../components/select/Select.tsx';
import RTextEditor from '../../../../components/richTextEditor/RTextEditor.jsx';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../utils/store.tsx';
import slice, { fields, FormikContext, initialValues, formSchema, prepareForm, prepareData, proformaInvoiceStatusText } from './slice.tsx';
import jobSlice, { prepareData as jobPrepareData, JobAction, getId } from '../../slice.tsx';
// import { getProformaInvoiceStatusList } from '../billingJob/slice.tsx';
import { StyledPreview } from '../printPreview/Page.tsx';

import { warning, info, emailValidation, downloadPDF, getCurrency } from '../../../../utils/utils.tsx';
import { ProformaInvoiceStatus, ProformaPaymentType, AccountMetaType } from '../../../../utils/enums.tsx';

// import { ReactComponent as XIcon } from "../../../../../v5/assets/icons/x.svg";

import Preview from './Preview.tsx';

// ----------------------------------------------------------------------

// const StyledDropdownButton = styled(DropdownButton)`
//   .dropdown-toggle {
//     border-radius: 100px;
//     padding-right: 15px;
//     padding-left: 15px;
//     color: white !important;

//     &::after {
//       border: unset;
//       content: '';
//       display: inline-block;
//       width: 16px;
//       height: 16px; 
//       background-image: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"%3E%3Cpath d="M6 9L12 15L18 9" stroke="%23181C32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/%3E%3C/svg%3E');
//       background-repeat: no-repeat;
//       background-size: contain;
//       margin-left: 5px;
//       vertical-align: sub;
//     }

//     .ant-divider {
//       margin-left: 7px;
//       margin-right: 0px;
//       border-color: rgba(255, 255, 255, 0.5) !important;
//     }

//     ${(props: any) => {
//       if(props.status === ProformaInvoiceStatus.Sent){
//           return `
//             background-color: var(--bs-yellow-500) !important;
//             border-color: var(--bs-yellow-500) !important;
//           `
//       } else if(props.status === ProformaInvoiceStatus.Accepted){
//           return `
//             background-color: #8908B7 !important;
//             border-color: #8908B7 !important;
//           `
//       } else if(props.status === ProformaInvoiceStatus.Declined){
//           return `
//             background-color: var(--bs-red-500) !important;
//             border-color: var(--bs-red-500) !important;
//           `
//       } else if(props.status === ProformaInvoiceStatus.Paid){
//           return `
//             background-color: var(--bs-green-500) !important;
//             border-color: var(--bs-green-500) !important;
//           `
//       } else {
//           return `
//             background-color: var(--bs-gray-600) !important;
//             border-color: var(--bs-gray-500) !important;
//           `
//       }
//     }}
//   }
// `;

// ----------------------------------------------------------------------

const PageComponent = (props: any) => {
  // const { user }: any = useAuthContext();
  // const { userAccount } = user ?? {};
  // const someField = userAccount?.someField;

  const router = useRouter();

  
  const headerHeight = document.getElementById('printpreview_header_ID')?.clientHeight || 82;
  const footerHeight = document.getElementById('printpreview_footer_ID')?.clientHeight || 71;
  document.documentElement.style.setProperty('--printpreview-header-height', `${(headerHeight)}px`);
  document.documentElement.style.setProperty('--printpreview-footer-height', `${(footerHeight)}px`);


  const { isLoading, show, form, isLoadingAccountBillingProfile, accountBillingProfile, tab } = useTypedSelector((state: RootState) => state.jobFormProformaInvoiceSlice);
  const dispatch = useDispatch<AppDispatch>();


  React.useEffect(() => {
    if(show){
      setValues(form);
      
      let accountBillingProfileId = (form && form?.customer) ? form?.customer?.accountBillingProfileId : null;
      dispatch(slice.callDetailsAccountBillingProfileApi(accountBillingProfileId, (state: boolean, data: any) => {}));

      router.removeParamFromUrl('profoerma-invoice');
    }
  }, [show, form])

  React.useEffect(() => {
    if(show){
      dispatch(slice.setLoading(true));
      let formData = prepareForm(form, initialValues, accountBillingProfile);
      setValues(formData);
      // setTimeout(() => {
      //     setErrors({});
      // }, 0);
      dispatch(slice.setLoading(false));
    }
  }, [accountBillingProfile])
  
    
  const formik = useFormik({
    initialValues: initialValues,
    // validateOnMount: false,
    // validateOnChange: false,
    validationSchema: formSchema(null),
    onSubmit: values => {},
  });
  const { values, errors, setValues, setFieldValue, setErrors, validateForm, handleSubmit }: any = formik;
  

  const onCancel = () => {
    dispatch(slice.setShow({ show: false, form: null }));
    dispatch(slice.setTab('tab1'));
  }
  const isInvalid = () => {
    return (errors && Object.entries(errors).length > 0)

    // let state = true;

    // let emailAddresses = (values && values.emailAddresses && values.emailAddresses.length > 0) ? values.emailAddresses : [];
    // let fromName = (values && values.fromName && values.fromName != '') ? values.fromName : '';
    // let subject = (values && values.subject && values.subject != '') ? values.subject : '';
    // let messagePlainText = (values && values.messagePlainText && values.messagePlainText != '') ? values.messagePlainText : '';

    // if(fromName != ''&& messagePlainText != '' && subject != '' && emailAddresses.length > 0){
    //   state = false;
    // }

    // return state;
  }

  const print = () => {
    let data = prepareData(values);
    data['isProformaInvoice'] = true;

    localStorage.setItem("jobIframeData", JSON.stringify(data));

    const link = document.createElement("a");
    link.href = "/Job-Iframe";
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  const sendEmail = () => {
    let data = prepareData(values);
    dispatch(slice.callSendCompleteJobEmailApi(data, (state: boolean, data: any) => {
      if(state){
        info('Send email', 'You will receive an mail soon');

        if(form?.proformaInvoiceStatus === ProformaInvoiceStatus.Draft){
          if(props.onChangeStatus){
            onCancel();

            props.onChangeStatus(ProformaInvoiceStatus.Sent);
          }
        }
      }
    }));
  }
  const savePayment = () => {
    let data = prepareData(values);
    if(props && props.onSavePayment){
      props.onSavePayment(data);
    }

    onCancel();
  }
  const download = () => {
    info('Download', 'Please Wait ...');

    let data = prepareData(values);
    dispatch(slice.callGetJobDocApi(data, (state: boolean, data: any) => {
      if(state){
        let fileName = form?.jobNumber + '-' +form?.customer?.billingName  + ".pdf"
        downloadPDF(fileName, data);
      }
    }));
  }
  const generate = () => {
    dispatch(slice.setLoading(true));

    let data = jobPrepareData(form, JobAction.Save, null);
    data['generateProformaInvoice'] = true;
    dispatch(jobSlice.callUpdateApi(data, (state: boolean, data: any) => {
      if(state){
        router.reloadWithParam('profoerma-invoice', 'true');
      }

      dispatch(slice.setLoading(false));
    }));
  }
  const changeStatus = (proformaInvoiceStatus: any) => {
    // let data = jobPrepareData(form, JobAction.Save, null);
    // data['proformaInvoiceStatus'] = proformaInvoiceStatus;
    // dispatch(jobSlice.callUpdateApi(data, (state: boolean, data: any) => {
    //   if(state){
    //     router.reload();
    //   }
    // }));

    if(props && props.onChangeStatus){
      onCancel();
      
      props.onChangeStatus(proformaInvoiceStatus);
    }
  }


  const footerElements = () => {
    return <Row className='w-100 gx-12'>
      <Col xs={true}></Col>

      {
        (form && form?.proformaInvoiceNumber && form?.proformaInvoiceNumber != '')
        ?
        <Col xs={'auto'} className='text-end'>
          <Button
            variant={'custom-outlined'}
            size={'sm'}
            className='me-12'
            disabled={false}
            onClick={(e) => {
              print();
            }}
          >Print</Button>

          <Button
            variant={'custom-primary'}
            size={'sm'}
            disabled={false}
            onClick={(e) => {
              download();
            }}
          >Download</Button>
        </Col>
        :
        <Col xs={'auto'} className='text-end'>
          <Button
            variant={'custom-primary'}
            size={'sm'}
            disabled={isLoading}
            onClick={(e) => {
              generate();
            }}
          >Generate Proforma</Button>
        </Col>
      }
    </Row>
  }

  const tabsElements = () => {
    return <Row className='g-24 align-items-center'>
      <Col xs={12}>
        <Tabs
          activeKey={tab}
          onSelect={(eventKey: any) => {
            dispatch(slice.setTab(eventKey));
          }}
        >
          <Tab eventKey={'tab1'} title={'Payment'} />
          <Tab eventKey={'tab2'} title={'Send Email'} />
        </Tabs>
      </Col>
      <Col xs={12}>
        {(tab === 'tab1' && <>{paymentElements()}</>)}
        {(tab === 'tab2' && <>{sendEmailElements()}</>)}
      </Col>
    </Row>
  }


  const paymentElements = () => {
    return <Row className='g-24 align-items-center'>
      <Col xs={12}>
        <Form.Group>
          <Form.Label>{fields.proformaInvoiceTotal.label}</Form.Label>
          <Form.Control
            as={CurrencyInput}
            allowDecimals={true}
            allowNegativeValue={true}
            prefix={getCurrency()}
            decimalsLimit={2}

            autoComplete='off'
            placeholder={fields.proformaInvoiceTotal.placeholder}
            disabled={false}
            value={values.proformaInvoiceTotal}
            onValueChange={(value: any) => {
              setFieldValue('proformaInvoiceTotal', value);
            }}
            isInvalid={!!(errors && errors.proformaInvoiceTotal)}
          />
          <Form.Control.Feedback type="invalid">{errors && errors.proformaInvoiceTotal as ReactNode}</Form.Control.Feedback>
        </Form.Group>
      </Col>

      <Col xs={12}>
        <Form.Group>
          <Form.Label>{fields.proformaPaymentMethodMetaId.label}</Form.Label>
          <Form.Control
            as={SmartSelect}
            isInvalid={!!(errors && errors.proformaPaymentMethodMetaId)}
            value={values.proformaPaymentMethodMetaId}
            placeholder={fields.proformaPaymentMethodMetaId.placeholder}
            addText={'Add new payment method'}
            apiPath={'accountMeta'}
            customParams={{
              types: AccountMetaType.PaymentMethod.toString(),
            }}
            readResponseFunc={(options: any) => {
              return (options && options.length > 0) ? options : [];
            }}
            fieldNames={{ value: 'accountMetaId', label: 'value' }}
            selected={{ accountMetaId: values.proformaPaymentMethodMetaId, value: values.proformaPaymentMethodMetaName }}
            hasOptionRender={false}
            hasFooterRender={false}
            searchable={false}
            allowClear={true}
            selectedIcon={false}
            disabled={false}
            loading={false}
            virtual={true}
            onChangeValue={async (value: any, option: any, ref: any) => {
              if(option){
                await setFieldValue('proformaPaymentMethodMetaId', value);
                await setFieldValue('proformaPaymentMethodMetaName', option.value);
              } else {
                await setFieldValue('proformaPaymentMethodMetaId', null);
                await setFieldValue('proformaPaymentMethodMetaName', '');
              }
            }}
          />
          <Form.Control.Feedback type="invalid">{errors && errors.proformaPaymentMethodMetaId as ReactNode}</Form.Control.Feedback>
        </Form.Group>
      </Col>

      <Col xs={12}>
        <Form.Group as={Row} className='checkbox-field align-items-center w-100 g-0'>
          <Form.Label column xs={true} className='m-0'>{fields.proformaPaymentType.label}</Form.Label>
          <Col xs={'auto'}>
            <Switch
              checked={(values.proformaPaymentType == ProformaPaymentType.CollectedByDriver)}
              onChange={(checked) => {
                if(checked){
                  setFieldValue('proformaPaymentType', ProformaPaymentType.CollectedByDriver);
                } else {
                  setFieldValue('proformaPaymentType', ProformaPaymentType.NotCollectedByDriver);
                }
              }}
            />
          </Col>
        </Form.Group>
      </Col>

      <Col xs={12}>
        <Form.Group>
          <Form.Label>{fields.proformaPaymentReceived.label}</Form.Label>
          <Form.Control
            as={CurrencyInput}
            allowDecimals={true}
            allowNegativeValue={false}
            prefix={getCurrency()}
            decimalsLimit={2}

            autoComplete='off'
            placeholder={fields.proformaPaymentReceived.placeholder}
            disabled={false}
            value={values.proformaPaymentReceived}
            onValueChange={(value: any) => {
              setFieldValue('proformaPaymentReceived', value);
            }}
            isInvalid={!!(errors && errors.proformaPaymentReceived)}
          />
          <Form.Control.Feedback type="invalid">{errors && errors.proformaPaymentReceived as ReactNode}</Form.Control.Feedback>
        </Form.Group>
      </Col>
      <Col xs={12}>
        <Button
          variant={'custom-primary'}
          size={'sm'}
          className='me-12'
          disabled={false}
          onClick={(e) => {
            savePayment();
          }}
        >Save</Button>
      </Col>
    </Row>
  }

  const sendEmailElements = () => {
    return <Row className='g-24 align-items-center'>
      <Col xs={12}>
        <Form.Group>
          <Form.Label>{fields.fromName.label}</Form.Label>
          <Form.Control
            type={'text'}
            autoComplete='off'
            size={'sm'}
            placeholder={fields.fromName.placeholder}
            disabled={false}
            value={values?.fromName}
            onChange={(e) => {
              setFieldValue('fromName', e.target.value);
            }}
            isInvalid={!!(errors && errors.fromName)}
          />
          <Form.Control.Feedback type="invalid">{errors && errors.fromName as ReactNode}</Form.Control.Feedback>
        </Form.Group>
      </Col>
      <Col xs={12}>
        <Form.Group>
          <Form.Label>{fields.emailAddresses.label}</Form.Label>
          <Form.Control
            as={Select}
            value={values?.emailAddresses}
            mode="tags"
            tokenSeparators={[',', ' ']}
            placeholder={fields.emailAddresses.placeholder}
            searchable={false}
            allowClear={true}
            selectedIcon={true}
            loading={false}
            onChangeValue={(value: any, option: any, ref: any) => {
              let pattern = emailValidation();
              let validEmails = value.filter((email: any) => email.match(pattern) !== null);

              if (value.length > validEmails.length) {
                warning('Warning', 'You must enter a valid email address');
              }

              setFieldValue('emailAddresses', validEmails);
            }}
            options={values?.contactEmails}
            isInvalid={!!(errors && errors.emailAddresses)}
          />
          <Form.Control.Feedback type="invalid">{errors && errors.emailAddresses as ReactNode}</Form.Control.Feedback>
        </Form.Group>
      </Col>
      <Col xs={12}>
        <Form.Group>
          <Form.Label>{fields.subject.label}</Form.Label>
          <Form.Control
            type={'text'}
            autoComplete='off'
            size={'sm'}
            placeholder={fields.subject.placeholder}
            disabled={false}
            value={values?.subject}
            onChange={(e) => {
              setFieldValue('subject', e.target.value);
            }}
            isInvalid={!!(errors && errors.subject)}
          />
          <Form.Control.Feedback type="invalid">{errors && errors.subject as ReactNode}</Form.Control.Feedback>
        </Form.Group>
      </Col>
      <Col xs={12}>
        <Form.Group>
          <Form.Label>{fields.message.label}</Form.Label>
          <Form.Control
            as = {RTextEditor}
            placeholder={fields.message.placeholder}
            editorState={values?.message}
            onChangeValue={(plainText: any, html: any, editorState: any) => {
              setFieldValue('messagePlainText', plainText);
              setFieldValue('messageHTML', html);
              setFieldValue('message', editorState);
            }}
            isInvalid={!!(errors && errors.messagePlainText)}
          />
          <Form.Control.Feedback type="invalid">{errors && errors.messagePlainText as ReactNode}</Form.Control.Feedback>
        </Form.Group>
      </Col>
      <Col xs={12}>
        <Button
          variant={'custom-primary'}
          size={'sm'}
          className='me-12'
          disabled={isInvalid()}
          onClick={(e) => {
            sendEmail();
          }}
        >Send Email</Button>
      </Col>
    </Row>
  }


  return <Offcanvas
    enforceFocus={false}
    backdrop={'static'}
    scroll={false}
    placement={'end'}
    show={show}
    onHide={() => {
      onCancel();
    }}
    style={{ width: (form && form?.proformaInvoiceNumber && form?.proformaInvoiceNumber != '') ? '90%' : 'auto' }}
  >
    <FormikContext.Provider value={formik}>
      <Offcanvas.Header id={'printpreview_header_ID'} closeButton>
        <Offcanvas.Title>
          <Row className='align-items-center'>
            <Col xs={'auto'}>Send Email</Col>
            {/* {(form && form?.proformaInvoiceNumber && form?.proformaInvoiceNumber != '') && <Col xs={'auto'}>
              <StyledDropdownButton
                status={values?.proformaInvoiceStatus}
                variant={'custom-primary'}
                size={'sm'}
                title={<>
                  {proformaInvoiceStatusText(values?.proformaInvoiceStatus, 0, 0, true)}
                  <Divider type='vertical' />
                </>}
              >
                {getProformaInvoiceStatusList(values, true).map((item: any, i: number) => {
                  return <Dropdown.Item
                    key={'jobform_proformainvoice_header_status_item' + i}
                    active={false}
                    onClick={async () => {
                      await setFieldValue('proformaInvoiceStatus', item?.value);

                      changeStatus(item?.value);
                    }}
                  >
                    <span className={item?.className}>{item?.label}</span>
                  </Dropdown.Item>
                })}
              </StyledDropdownButton>
            </Col>} */}
          </Row>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Spin spinning={
          isLoading || 
          isLoadingAccountBillingProfile
        }>
          <Row className='g-24'>
            {(form && form?.proformaInvoiceNumber && form?.proformaInvoiceNumber != '') && <Col xs={12} lg={5}>
              {/* {tabsElements()} */}
              {sendEmailElements()}
            </Col>}
            <Col xs={12} lg={(form && form?.proformaInvoiceNumber && form?.proformaInvoiceNumber != '') ? 7 : 12}>
              <StyledPreview>
                <Preview />
              </StyledPreview>
            </Col>
          </Row>
        </Spin>
      </Offcanvas.Body>
      <Modal.Footer id={'printpreview_footer_ID'} className='border-top'>{footerElements()}</Modal.Footer>
    </FormikContext.Provider>
  </Offcanvas>
}

export default PageComponent;
